(function (root) {
  // Der Vertrag, den eine portierte Brand-Section am Fenster vorfindet: die Felder, die ihr Code liest,
  // und die Übersetzung zwischen dem einen Warenkorb-Ereignis des Kerns und den "theme:cart:*" davor.
  // Läuft nach theme.js, sonst gibt es kein window.theme zum Füllen.
  var doc = root.document;
  var theme = root.theme;
  if (!theme || !theme.cart) return;

  var script = doc.currentScript;
  var data = script && script.dataset ? script.dataset : {};
  var body = doc.body && doc.body.dataset ? doc.body.dataset : {};

  theme.moneyFormat = data.moneyFormat || '';
  theme.moneyWithCurrencyFormat = data.moneyWithCurrencyFormat || '';
  theme.current_iso_code = data.currencyCode || '';
  theme.strings = { remove: data.removeLabel || '' };
  // c-price schreibt jeden Betrag mit money, nie mit dem Währungscode; der Port liest dasselbe Format.
  theme.settings = { currency_code_enable: false };
  theme.routes = {
    cart_url: body.cartUrl || '',
    cart_add_url: body.cartAddUrl || '',
    cart_update_url: body.cartUpdateUrl || '',
  };

  // Was der Kern selbst sendet, trägt diese Herkunft; seine eigenen Zuhörer überspringen es.
  var ORIGIN = 'core';

  function send(name, detail) {
    var payload = { origin: ORIGIN };
    for (var key in detail) {
      if (Object.prototype.hasOwnProperty.call(detail, key)) payload[key] = detail[key];
    }
    doc.dispatchEvent(new root.CustomEvent(name, { bubbles: true, detail: payload }));
  }

  function fromCore(event) {
    return !!(event && event.detail && event.detail.origin === ORIGIN);
  }

  function loaded(cart) {
    send('theme:cart:loaded', { cart: cart || null });
  }

  doc.addEventListener('cart:updated', function (event) {
    var detail = event.detail || {};
    if (detail.added) send('theme:cart:added', { cart: detail.cart, added: detail.added, source: detail.source });
    else send('theme:cart:refresh', { cart: detail.cart, source: detail.source });
  });

  doc.addEventListener('theme:cart:add', function (event) {
    if (fromCore(event)) return;
    var button = event.detail && event.detail.button;
    var form = button && button.closest ? button.closest('form') : null;
    if (!form) return;
    // The sender submits the form itself unless someone took the add.
    if (event.preventDefault) event.preventDefault();
    theme.cart.add(new root.FormData(form), 'theme-event').catch(function () {});
  });

  doc.addEventListener('theme:cart:update', function (event) {
    if (fromCore(event)) return;
    var detail = event.detail || {};
    if (detail.id === undefined || detail.quantity === undefined) return;
    theme.cart.change({ id: detail.id, quantity: detail.quantity }, 'theme-event').catch(function () {});
  });

  // Die Section-Markup kommt aus Liquid; den Warenkorb selbst holt der Kern danach für die Zuhörer.
  doc.addEventListener('theme:cart:refresh', function (event) {
    if (fromCore(event)) return;
    theme.cart
      .refresh()
      .then(function () {
        return theme.cart.get();
      })
      .then(loaded, function () {
        loaded(null);
      });
  });
})(window);
